<script>
import MixedIcons from '../../../assets/icons/MixedIcons.vue';
import Documents from '../../documents/Documents.vue';

export default {
    props: {
        Quarter: {
            type: Object,
            required: true,
        },
        
        Year: {
            type: Number,
            required: true,
        },

        Inputs: {
            type: Object,
            required: true,
        },

        SelectedFacilityId: {
            type: Number,
            required: true,
        },

        GeneralColorCode: {
            type: String,
            required: true,
        },
    },

    components: {
        MixedIcons,
        Documents,
    },

    data() {
        return {

        }
    },

    computed: {
        Input() {
            if (this.isNullish(this.Year) || this.isNullish(this.Quarter) || this.isNullish(this.Quarter.value) || this.isNullish(this.SelectedFacilityId))
                return null;

            return this.Inputs.find(x => x.facility_id === this.SelectedFacilityId && x.year == this.Year && x.quarter == this.Quarter.value);
        },
        
        SideClass() {
            if (!this.Input)
                return null;

            return this.Input.has_document ? 'fa-solid fa-check' : null;
        },

        kpiType() {
            if (!this.Input)
                return false;

            return this.Input.sub_metric_kpi_id ? 'sub_metric' : 'metric';
        },
    },

    methods: {
        EmitEvent(action) {
            this.$emit(action, this.Input);
        },

        openDocumentsModal() {
            if (!this.Input) {
                console.error(`Input for the given metric, year and quarter was not found! Year: ${year} - Quarter: ${quarter}`);
                return;
            }

            this.$refs.documentsPopup.openPopup();
        },

        isNullish(val) {
            return val === null || val === undefined || val === NaN;
        },
    }
}
</script>

<template>
    <div class="metric-input-field-header">
        {{ Quarter.text }}
        <mixed-icons class="documentation-icon" :class="{ 'disabled-icon': !Input }" 
            :hover="Input != null"
            :name="'fa-regular fa-folder-open'" 
            :main_color="Input != null ? GeneralColorCode : 'lightgray'"
            :side_class="SideClass" 
            :side_color="'var(--sustainfinity-green)'" 
            @click="openDocumentsModal()"
        />

        <sust-popup v-if="Input" ref="documentsPopup" :footer="false" :header="false" size="xl">
            <div style="width: 100%; min-height: fit-content;">
                <Documents :Category="kpiType" :InputId="Input.metrics_input_table_id" />
            </div>
        </sust-popup>
    </div>
</template>

<style lang='scss' scoped>
.metric-input-field-header {
    position: relative;
    padding: .33em .66em;
    width: 100%;
    text-align: center;
}

.documentation-icon {
    position: absolute;
    bottom: -.33em !important;
    right: -.66em !important;
    scale: .5;

    color: whitesmoke;

    transition: 100ms;
    cursor: pointer;
    &:hover {
        filter: brightness(50%);
    }
}

.disabled-icon {
    pointer-events: none !important;
}
</style>